import React from 'react';
import { CustomTextareaProps } from './types/CustomInputsTypes';
// import { getAuthData } from '@/utils/auth';

const UserCustomerTextArea: React.FC<CustomTextareaProps> = ({
  label,
  name,
  value,
  onChange,
  // placeholder = '',
  maxLength,
  error,
  required = false,
  description,
  className,
  rows = 4,
  textAreaClassname = '',
  isCondition = true,
  isLockedByMe,
  lockedOwner = '',
  isReviewForm,
  isPdf = false,
}) => {
  // const { role } = getAuthData();

  return (
    <div>
      {isCondition ? (
        <label className="text-gray-2250 text-xs font-semibold">{label}</label>
      ) : (
        <label className="mt-4  font-semibold text-ds-gray-800  block">
          {label}
          {required && <span className="text-ds-red-400"> *</span>}
        </label>
      )}

      {description && (
        <p
          className={`mt-1 text-xs ${isCondition ? 'font-normal text-ds-gray-300' : 'font-semibold text-ds-gray-500'}`}
        >
          {description}
        </p>
      )}

      {!isPdf ? (
        <div className="relative py-2">
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            placeholder={'Description'}
            maxLength={maxLength}
            rows={rows}
            disabled={isReviewForm || (lockedOwner !== '' && !isLockedByMe)}
            className={`${className} w-full border-2 rounded-md px-2 py-2 text-xs text-ds-gray-500 outline-none resize-none placeholder:text-ds-gray-300 ${textAreaClassname} ${
              error ? 'border-ds-red-400' : 'border-ds-gray-100'
            }`}
          />
          {error && <p className="w-[360px] pt-1 text-xs font-normal text-ds-red-400">{error}</p>}
        </div>
      ) : (
        <div className="text-xs mt-6 text-ds-gray-500">{value}</div>
      )}
    </div>
  );
};

export default UserCustomerTextArea;
